import Footer from '@/components/Layout/Footer/Footer';
import React, { useState } from 'react';
import UserHeadBar from '../../components/UserHeadBar';
import { useNavigate } from 'react-router-dom';
import user from '@/assets/anderson.png';
import video from '@/assets/video.svg';
import call from '@/assets/call-calling.svg';
import sender from '@/assets/tennt.png';
import { Button } from '@/components/Elements';
export const SellerInformation = () => {
  const navigate = useNavigate();
  return (
    <>
      <UserHeadBar content="View Seller Information." />
      <div className="container my-5">
        <div className="row seller-info-rw">
          <div className="col-12 col-md-5">
            <div className="seller-inf-bs">
              <div className="seller-inner-box">
                <h5 className="f-16 text-dark font-semibold">Seller Details</h5>
                <p className="name-lst border-btm  text-dark  py-2 d-flex justify-between mb-0">
                  <span>Name</span>
                  <span>Sam</span>
                </p>
                <p className="name-lst border-btm text-dark  py-2 d-flex justify-between mb-0">
                  <span>Message Status</span>
                  <span style={{ color: 'green' }}>Message Sent</span>
                </p>
                <p className="name-lst border-btm text-dark  py-2 d-flex justify-between mb-0">
                  <span>Email</span>
                  <span>example123@gmail.com</span>
                </p>
                <p className="name-lst border-btm text-dark  py-2 d-flex justify-between mb-0">
                  <span>Contact</span>
                  <span>1256854256</span>
                </p>
                <p className="name-lst border-btm text-dark  py-2 d-flex justify-between mb-0">
                  <span>Address</span>
                  <span>Lorem ipsum</span>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-7">
            <div className="seller-inf-bs">
              <div className="seller-inner-box">
                <div className="chat-messages w-100 border-0">
                  <div className="chat-header d-flex justify-between">
                    <div className="user-header-icon d-flex gap-2 align-items-center">
                      <img src={user} className="headerr-user" />
                      <p className="semi-bold text-black f-14 mb-0">Athalia Putri</p>
                    </div>
                    <div className="char-video-option d-flex gap-2 align-items-center">
                      <Button className="video-call">
                        <img src={video} />
                      </Button>
                      <Button className="video-call">
                        <img src={call} />
                      </Button>
                      <Button className="video-options bg-transparent border-0">
                        <i className="fa-solid fa-ellipsis-vertical text-black"></i>
                      </Button>
                    </div>
                  </div>
                  <hr />
                  <div className="chat-messages-box">
                    <div className="sender-messages">
                      <div className="sender-msg mb-2">
                        <p className="f-14 text-white mb-0">
                          Hi, good afternoon natasya wilodra ...
                        </p>
                      </div>
                      <div className="sender-msg mb-2">
                        <p className="f-14 text-white mb-0">
                          I want to book your villa for 5 days can it?
                        </p>
                      </div>
                      <div className="sender-image">
                        <img src={sender} className="sender-icon" />
                      </div>
                    </div>
                    <div className="receiver-messages">
                      <div className="receive-msg mb-2">
                        <p className="f-14 mb-0">Hi, good afternoon natasya wilodra ...</p>
                      </div>
                      <div className="receive-msg mb-2">
                        <p className="f-14 mb-0">I want to book your villa for 5 days can it?</p>
                      </div>
                      <div className="receiver-image">
                        <img src={sender} className="receiver-icon" />
                      </div>
                    </div>
                  </div>
                  <div className="chat-fixed-bottom">
                    <form>
                      <div className="relative chat-bottom">
                        <Button className="attach-file  bg-transparent p-0 border-0">
                          <i className="fa-solid fa-paperclip text-black"></i>
                        </Button>

                        <Button className="sbmt-camera bg-transparent border-0 p-0">
                          <i className="fa-solid fa-camera text-black"></i>
                        </Button>
                        <input
                          className="form-control "
                          name="submit"
                          placeholder="Type your Message..."
                        />

                        <Button className="sbmt-chat border-0">
                          <i className="fa-solid fa-paper-plane text-white"></i>
                        </Button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
